import { r as T, c as s, i as F, h as a, H as M, g as R, o as l } from "./main-bb89b2f2.js";
import { T as n } from "./translation-service-06f7c8c7-b6396601.js";
import { u as P } from "./unique-id-1206d8f1-53216113.js";
import "vue";
const d = "Sidebar", b = "Sidebar schließen", W = {
  sidebarAriaLabel: d,
  closeButtonAriaLabel: b
}, q = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: d,
  closeButtonAriaLabel: b,
  default: W
}), h = "Sidebar", u = "Close Sidebar", K = {
  sidebarAriaLabel: h,
  closeButtonAriaLabel: u
}, Z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: h,
  closeButtonAriaLabel: u,
  default: K
}), p = "Barra lateral", g = "Cerrar barra lateral", D = {
  sidebarAriaLabel: p,
  closeButtonAriaLabel: g
}, N = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: p,
  closeButtonAriaLabel: g,
  default: D
}), f = "Barre latérale", m = "Fermer la barre latérale", V = {
  sidebarAriaLabel: f,
  closeButtonAriaLabel: m
}, Y = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: f,
  closeButtonAriaLabel: m,
  default: V
}), L = "Barra laterale", A = "Chiudi barra laterale", G = {
  sidebarAriaLabel: L,
  closeButtonAriaLabel: A
}, Q = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: L,
  closeButtonAriaLabel: A,
  default: G
}), v = "サイドバー", y = "サイドバーを閉じる", U = {
  sidebarAriaLabel: v,
  closeButtonAriaLabel: y
}, X = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: v,
  closeButtonAriaLabel: y,
  default: U
}), x = "사이드바", w = "사이드바 닫기", ee = {
  sidebarAriaLabel: x,
  closeButtonAriaLabel: w
}, te = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: x,
  closeButtonAriaLabel: w,
  default: ee
}), _ = "Zijbalk", B = "Zijbalk sluiten", ae = {
  sidebarAriaLabel: _,
  closeButtonAriaLabel: B
}, ie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: _,
  closeButtonAriaLabel: B,
  default: ae
}), k = "Pasek boczny", O = "Zamknij pasek boczny", re = {
  sidebarAriaLabel: k,
  closeButtonAriaLabel: O
}, oe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: k,
  closeButtonAriaLabel: O,
  default: re
}), C = "Barra lateral", z = "Fechar barra lateral", se = {
  sidebarAriaLabel: C,
  closeButtonAriaLabel: z
}, le = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: C,
  closeButtonAriaLabel: z,
  default: se
}), S = "Боковая панель", $ = "Закрыть боковую панель", ne = {
  sidebarAriaLabel: S,
  closeButtonAriaLabel: $
}, ce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: S,
  closeButtonAriaLabel: $,
  default: ne
}), j = "Kenar Çubuğu", H = "Kenar Çubuğunu Kapat", de = {
  sidebarAriaLabel: j,
  closeButtonAriaLabel: H
}, be = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: j,
  closeButtonAriaLabel: H,
  default: de
}), E = "侧边栏", I = "关闭侧边栏", he = {
  sidebarAriaLabel: E,
  closeButtonAriaLabel: I
}, ue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  sidebarAriaLabel: E,
  closeButtonAriaLabel: I,
  default: he
}), pe = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.top-0{top:var(--spacing-0)}.left-\\[100\\%\\]{left:100%}.top-\\[10px\\]{top:10px}.right-\\[12px\\]{right:12px}.top-\\[20px\\]{top:20px}.z-\\[999\\]{z-index:999}.block{display:block}.flex{display:flex}.h-full{height:100%}.w-full{width:100%}.cursor-pointer{cursor:pointer}.items-center{align-items:center}.bg-white{background-color:var(--color-white)}.pl-\\[30px\\]{padding-left:30px}.pt-\\[70px\\]{padding-top:70px}.pb-\\[20px\\]{padding-bottom:20px}.pt-\\[15px\\]{padding-top:15px}.pr-\\[30px\\]{padding-right:30px}.text-copy-smaller{font-size:var(--copytext-font-size-smaller)}.uppercase{text-transform:uppercase}.text-gray-800{color:var(--color-neutral-steel-800)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}:host{display:block}.sidebar-wrapper{background-color:var(--color-white);height:100%;left:100%;padding-bottom:20px;padding-left:30px;padding-top:70px;position:fixed;top:var(--spacing-0);transition:left .3s ease-out;width:100%;z-index:999}.sidebar-wrapper.no-animation{transition:none}.sidebar-wrapper.is-open{left:0;visibility:visible}.close-menu{cursor:pointer;position:absolute;right:12px;top:10px;z-index:10}.close-menu-header{align-items:center;color:var(--color-neutral-steel-800);display:flex;font-size:var(--copytext-font-size-smaller);letter-spacing:var(--letter-spacing-basic);min-width:200px;position:absolute;text-transform:uppercase;top:20px}.close-menu-header:active{color:var(--color-black)}.sidebar-content{height:100%;overflow-y:auto;padding-right:30px;padding-top:15px}@media (min-width:992px){.sidebar-wrapper{max-width:380px;transition:left .3s ease-out,box-shadow .3s ease-out}.sidebar-wrapper.no-animation{transition:none}.sidebar-wrapper.is-open{--tw-shadow:var(--shadow-elevation-middle);--tw-shadow-colored:var(--shadow-elevation-middle);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);left:calc(100% - 380px)}.lg\\:max-w-\\[380px\\]{max-width:380px}}.static{position:static}.relative{position:relative}.hidden{display:none}", ge = pe, c = {
  de: q,
  en: Z,
  es: N,
  fr: Y,
  it: Q,
  ja: X,
  pt: le,
  ru: ce,
  zh: ue,
  ko: te,
  nl: ie,
  pl: oe,
  tr: be
}, fe = class {
  constructor(e) {
    T(this, e), this.lhHeaderComponentRegister = s(this, "lhHeaderComponentRegister", 7), this.close = s(this, "lhClose", 7), this.languageCode = "", this.supportedLangs = ["de", "en", "es", "fr", "it", "ja", "ko", "nl", "pl", "pt", "ru", "tr", "zh"], this.emitCloseAllSidebarOverlays = () => {
      const t = new CustomEvent("_lhInternalCloseAllSidebarOverlays", {
        bubbles: !0,
        composed: !0
      });
      this.hostElement.dispatchEvent(t);
    }, this.handleModalClose = async () => {
      this.close.emit();
    }, this.handleOutsideClick = (t) => {
      t.target && !this.hostElement.contains(t.target) && this.close.emit();
    }, this.show = !1, this.noAnimation = !1, this.handleOutsideClickManually = !1, this.backLabel = "back", this.headerId = "", this.overlayId = void 0, this.sidebarOverlayAriaLabel = "", this.closeButtonAriaLabel = "", this.isMobile = !1, this.isTriggeredFromHeader = !1, this.i18nState = void 0;
  }
  /**
   * Watcher for the show property
   **/
  showWatcher(e) {
    this.handleOutsideClickManually || (e ? (document.addEventListener("mouseup", this.handleOutsideClick), this.emitCloseAllSidebarOverlays()) : document.removeEventListener("mouseup", this.handleOutsideClick));
  }
  async showOverlayFromHeader() {
    this.show = !0, this.isTriggeredFromHeader = !0;
  }
  async showOverlayFromBody() {
    this.show = !0, this.isTriggeredFromHeader = !1;
  }
  connectedCallback() {
    const e = (t) => {
      l("breakpoint", t) !== null && (this.isMobile = this.checkScreenSize());
      const i = l("lang", t);
      this.languageCode = "en", i && this.supportedLangs.includes(i) && (this.languageCode = i), this.i18nState = n.resolveJsonBasedOnLanguage(this.languageCode, c);
    };
    this.observer = new MutationObserver(e), this.observer.observe(document.documentElement, { attributes: !0 }), this.overlayId = this.overlayId || this.generateRandomId();
  }
  async componentWillLoad() {
    this.lhHeaderComponentRegister.emit("sidebar-overlay"), this.show && this.emitCloseAllSidebarOverlays(), this.languageCode = "en", document.documentElement.lang && this.supportedLangs.includes(document.documentElement.lang) && (this.languageCode = document.documentElement.lang), this.i18nState = n.resolveJsonBasedOnLanguage(this.languageCode, c);
  }
  componentDidLoad() {
    this.isMobile = this.checkScreenSize();
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  async onCloseAllSideBarOverlays(e) {
    (e.target.nodeName === "PATTERNLIB-SIDEBAR-OVERLAY" ? e.target.overlayId : null) !== this.overlayId && this.show && await this.handleModalClose();
  }
  handleEscapePress(e) {
    e.key === "Escape" && this.close.emit();
  }
  checkScreenSize() {
    return F(0, 992);
  }
  generateRandomId() {
    return "patternlib-sidebar-overlay-" + P();
  }
  getHeaderHeight() {
    if (this.isTriggeredFromHeader) {
      const e = document.querySelector("#" + this.headerId);
      if (e !== null)
        return e.getAttribute("main-navigation-offset");
    }
    return 0;
  }
  render() {
    const e = {
      "sidebar-wrapper": !0,
      "is-open": this.show,
      "header-overlay": this.isTriggeredFromHeader,
      "no-animation": this.noAnimation
    }, t = {
      height: this.isMobile && this.isTriggeredFromHeader ? `calc(100vh - ${this.getHeaderHeight()}px` : "",
      top: this.isMobile && this.isTriggeredFromHeader ? `${this.getHeaderHeight()}px` : "",
      visibility: this.show ? "visible" : "hidden"
      // a11y: hide when aria-hidden="true"
    }, r = this.isMobile && this.isTriggeredFromHeader ? this.backLabel : "";
    let i = this.closeButtonAriaLabel;
    i === "" && (i = this.i18nState.closeButtonAriaLabel);
    let o = this.sidebarOverlayAriaLabel;
    o === "" && (o = this.i18nState.sidebarAriaLabel);
    const J = a("div", { key: "00c5ae5369f7d3b01048cee95b080e45d9811788", role: "button", "aria-label": i, class: this.isMobile && this.isTriggeredFromHeader ? "close-menu-header" : "close-menu", onClick: this.handleModalClose }, r.length > 0 ? a("patternlib-link", { type: "prominent", variant: "action", icon: "arrow-left", label: r, class: "close-menu-header" }) : a("patternlib-icon-button", { class: "close-menu" }, a("patternlib-icon", { "icon-name": "x", tabindex: -1 })));
    return a(M, { key: "65c671ea85804cc18ae652592f126366c9061227" }, a("div", { key: "2f3ad8bc652d09c3a91e81fb15502f48468a94df", "aria-label": o, "aria-dialog": "true", "aria-hidden": this.show ? "false" : "true", class: e, style: t }, J, a("div", { key: "12f99a8431d554cfad65c81238a3e489cf9c8633", class: "sidebar-content relative" }, a("slot", { key: "76ae5e0c9553f14e8e581125d3237087dee59ada" }))));
  }
  get hostElement() {
    return R(this);
  }
  static get watchers() {
    return {
      show: ["showWatcher"]
    };
  }
};
fe.style = ge;
export {
  fe as patternlib_sidebar_overlay
};
